// extracted by mini-css-extract-plugin
export default {"main":"ProfesorSelector_main__bnm+v"};